
import SendIcon from "../../assets/icon/SendIcon";
import Microphone from "../../assets/icon/Microphone";
import Left from "../../assets/icon/Left";
import tripLogo from "../../assets/img/tripLogo.png";
import { axiosReq } from "../../commons/axiosReq"
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AudioWave from "../../assets/img/wave.png";
import axios from "axios";

const TripVoice = () => {

  const location = useLocation();
  const recommendations = location?.state?.recommendations || "";
  const [isStreaming, setIsStreaming] = useState(false);
  const audioChunksRef = useRef([]); // Stores recorded audio chunks
  const mediaRecorderRef = useRef(null); // MediaRecorder instance
  const websocketRef = useRef(null); // WebSocket instance
  const listRef = useRef(null);
  const endRef = useRef(null);
  const [snipper, setSnipper] = useState(false);
  const wsUrl = "wss://travel.knowtify.ir/voice_chat"; // WebSocket server URL

  // const toggleRecord = () => {
  //   setRecord(prev => !prev);
  //   // ===== اگر بعداً ضبط واقعی بخوای:
  //   // if (!record) startRecording();
  //   // else stopRecording();
  // };

const playAudioChunks = () => {
        setSnipper(false)
        if (audioChunksRef.current.length === 0) {
            console.log("No audio chunks to play.");
            return;
        }

        const audioBuffer = new Blob(audioChunksRef.current, { type: "audio/mp3" });
        const audioUrl = URL.createObjectURL(audioBuffer);
        const audio = new Audio(audioUrl);

        audio.onended = () => {
            console.log("Audio playback finished.");
            audioChunksRef.current = []; // Clear chunks after playing
        };

        audio.play();
    };
      const CreateUrl = async (blob, fileName) => {
        const file = new File([blob], fileName, { type: "audio/mp3" });
        console.log(222)
        console.log(file)
        const formData = new FormData();
        formData.append("FileDetails", file)
        // Create a downloadable link for the file
        // const link = document.createElement("a");
        // link.href = URL.createObjectURL(file);
        // link.download = fileName;
        // link.click();

        const dataFile = await axios.post("https://api.bordarna.ir/api/" + "Admins/UploadPhoto2", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
            ,
        });
        if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {
            // const pieces = dataFile?.data?.split('/')
            console.log(dataFile?.data)
            return ("https://api.bordarna.ir/uploads/" + dataFile?.data)
            // props.setFiles(true)
        }
        else {
            console.log(dataFile)
            return "false";
        }


        // Return the path (if needed for further use)
        // return `"C:\\Users\\ASUS\\Downloads"${fileName}.mp3`;
    };
  const toggleStreaming = async () => {
    if (isStreaming) {
      // Stop recording and WebSocket connection
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
        setIsStreaming(false);
        console.log("Streaming stopped.");
      }
      //if (websocketRef.current) {
      //    websocketRef.current.close();
      //}
      setIsStreaming(false);
      console.log("Streaming stopped.");
    } else {
      // Start recording and WebSocket connection
      try {
        setSnipper(true)
        websocketRef.current = new WebSocket(wsUrl);
        setIsStreaming(true);

        console.log(websocketRef.current)
        websocketRef.current.onopen = () => {
          console.log("WebSocket connection opened.");
          setSnipper(true)

          setIsStreaming(true);
        };

        websocketRef.current.onmessage = (event) => {
          console.log("WebSocket connection onmessage.");

          const serverResponse = JSON.parse(event.data);
          console.log(8888);
          console.log(serverResponse);

          if (serverResponse.type === "conversation") {
            // Handle conversation messages
            console.log(999);
            console.log(999);
            setSnipper(false)
            setMessages((prevMessages) => [
              ...prevMessages,
              // { text: serverResponse.prompt, sender: "user" },
              {
                text: <img className="w-full h-[40px]" src={AudioWave} alt="" />
                , sender: "user"
              },
              { text: serverResponse.answer, sender: "bot" }
            ]);
            // setMessages((prevMessages) => [...prevMessages, { text: chunk.replace(/(\r\n|\n|\r)/gm, ""), sender: "bot" }]);

          }
          else if (serverResponse.type === "audio") {
            // Handle audio chunks

            const decodedChunk = new Uint8Array(
              atob(serverResponse.data)
                .split("")
                .map((char) => char.charCodeAt(0))
            );
            audioChunksRef.current.push(decodedChunk);

          }
          else if (serverResponse.type === "text") {
            playAudioChunks();
          }
          return false;
        };

        websocketRef.current.onclose = () => {
          setSnipper(false)

          console.log("WebSocket connection closed.");
          setIsStreaming(false);
        };

        websocketRef.current.onerror = (error) => {
          setSnipper(false)

          console.error("WebSocket error:", error);
          setIsStreaming(false);
        };

        // Request microphone access
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        mediaRecorderRef.current = recorder;
        setSnipper(false)

        // Capture audio data chunks
        recorder.ondataavailable = (e) => {
          audioChunksRef.current.push(e.data);
        };

        // When recording stops, save audio and send file path to server
        recorder.onstop = async () => {
          const blob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
          audioChunksRef.current = []; // Clear chunks after saving

          // Save the audio file locally and send its path to the server
          const fileurl = await CreateUrl(blob, "arshia.mp3");
          console.log("Audio saved at:", fileurl);

          if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
            websocketRef.current.send(JSON.stringify({ file_url: fileurl }));
            console.log("Sent audio file path to the server.");
          }
        };

        // Start recording
        recorder.start();
        console.log("Audio recording started.");
      } catch (error) {
        console.error("Error starting streaming:", error);
      }
    }
  };
  const [messages,
    setMessages] = useState([
      {
        text: "سلام! کافیه یه ویس کوتاه برامون بفرستی و بگی کجا می‌خوای بری و تاریخ رفت‌وبرگشتت چیه، حدود بودجه‌ت چقدره، چند نفرید و با کی‌ها می‌رید، حال‌وهوای سفرت رو دوست داری لوکس باشه یا اقتصادی، آروم یا پرهیجان، هتل دلخواهت چه مدلیه (مثلاً چندستاره، چه محله‌ای و چه امکاناتی برات مهمه)، چه زمان‌هایی برای پرواز یا قطار بهتره و اگر نکته خاصی داری مثل نزدیک دریا بودن، اتاق بزرگ، همراه داشتن کودک یا سالمند… ما هم با همین اطلاعات، خیلی سریع بهترین پرواز و هتل و برنامه سفر رو برات می‌چینیم. مثلاً: «دو نفره برای استانبول ۲۰ تا ۲۴ مهر، بودجه هر نفر حدود ۳۰ تومن، هتل ۴ستاره نزدیک مرکز خرید، پرواز صبح؛ اگه تور کشتی هم باشه عالیه.» 🎙️ آماده‌ای؟ همین الان ویس بده! 😊",
        sender: "bot"
      }
    ]);
  const [input,
    setInput] = useState("");

  const handleSend = async () => {
    if (!input.trim()) return;


    const newMessages = [
      ...messages,
      { text: input, sender: "user" }
    ];
    setMessages(newMessages);
    setInput("");

    try {

      const response = await axiosReq("chat_assist", "post", {
        prompt: input
      });


      const data = response?.data;
      console.log(data)
      if (Array.isArray(data?.recommendations)) {
        console.log(data?.recommendations)
        // setMessages((prev) => [
        //   ...prev,
        //   {
        //     sender: "bot",
        //     text: "",
        //     type: "recommendations",
        //     recommendations: data.recommendations 
        //   }
        // ]);

        var req = []
        data?.map((item) => {

          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              text: {
                city: item.city,
                description: item.description
              },
              type: "recommendations"
            }
          ]);
        })



      } else {
        setMessages((prev) => [
          ...prev,
          {
            text: data?.answer || "پاسخی دریافت نشد.",
            sender: "bot"
          }
        ]);
      }
    } catch (err) {
      console.error("خطا در ارتباط با API:", err);
      setMessages((prev) => [
        ...prev,
        {
          text: "خطایی در ارتباط با سرور پیش آمد.",
          sender: "bot"
        }
      ]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter")
      handleSend();
  };

  useEffect(() => {
    console.log(999)

    console.log(recommendations)
    if (Array.isArray(recommendations) && recommendations.length > 0) {
      var req = []
      recommendations?.map((item) => {

        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: {
              city: item.city,
              description: item.description
            },
            type: "recommendations"
          }
        ]);
      })

    }
  }, []);
  useEffect(() => {
    // اسکرول نرم به آخر
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages]);

  // اختیاری: بارِ اول بدون انیمیشن بره پایین
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
  }, []);


  return (
    <div
      className="min-h-screen h-full flex flex-col lg:h-full  items-start bg-gray-100 tripBackgroud px-4 py-6">
      <div className="flex items-center mb-2 w-auto mx-auto mt-16">
        <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2 " />
        <span className="font-Beiruti text-[#265069] text-[20px]">
          چت بات گردشگری
        </span>
      </div>

      <div className=" w-[60%] mx-auto lg:w-full">

        <div >
          <div
            className="bg-white rounded-3xl shadow-lg p-8 w-full  mx-auto"
            id="chatBack">

            <div ref={listRef}
              className="w-full  flex-1 overflow-y-auto  p-4 space-y-3 h-[350px] min-h-[350px]" >
              {messages?.map((msg, index) => (
                <div
                  key={index}
                  className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                >
                  {msg.type === "recommendations" ? (
                    <div className="bg-cg text-gray-700 text-sm p-3 rounded-xl space-y-4 max-w-[75%]">
                      {/* {msg?.recommendations?.map((item, idx) => ( */}
                      <div style={{ marginBottom: "1.5rem" }}>
                        <h2 className="font-bold text-[#265069]">{msg?.text?.city}</h2>
                        <p className="whitespace-pre-line font-IRANYekanMedium">{msg?.text?.description}</p>
                      </div>
                      {/* ))} */}
                    </div>
                  ) : (
                    <div
                      className={`max-w-[75%] px-4 py-2 text-sm font-IRANYekanMedium ${msg.sender === "user"
                        ? "bg-cb text-blue-800 rounded-tr-xl rounded-tl-xl rounded-br-xl rounded-bl-sm"
                        : "bg-cg text-gray-700 rounded-tl-xl rounded-bl-xl rounded-tr-xl rounded-br-sm"
                        }`}
                    >
                      {msg.text}
                    </div>
                  )}
                </div>
              ))}

              <div ref={endRef} />
            </div>
            <div className="w-full mt-4 flex flex-wrap items-center gap-2 sm:gap-2 md:gap-3">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={isStreaming ? "در حال گوش دادن..." : "پیام خود را بنویسید..."}
                className="font-IRANYekanMedium flex-1 min-w-[40%] border border-[#0b94ca] xs:w-full xs:min-w-[100%] rounded-full px-4 py-2 text-sm xs:text-xs focus:outline-none focus:ring-2 focus:ring-[#0b94ca] disabled:opacity-70"
                disabled={isStreaming}
              />

              {/* دکمه میکروفن */}
              <button
                type="button"
                onClick={toggleStreaming}
                aria-pressed={isStreaming}
                aria-label={isStreaming ? "توقف ضبط" : "شروع ضبط"}
                className={`
      pulse-circle shrink-0 rounded-full grid place-items-center
      w-12 h-12 xs:w-11 xs:h-11 sm:w-12 sm:h-12 md:w-14 md:h-14
      bg-[#0b94ca] text-white hover:bg-[#087cad] transition
      ${isStreaming ? "ring-2 ring-[#79b9d1]" : ""}
    `}
              >
                {isStreaming ? (
                  <div className="audio-wave w-6 h-4 md:w-7 md:h-5 flex items-end justify-center gap-[2px]">
                    <span></span><span></span><span></span><span></span><span></span>
                          <p className="text-[20px] font-IRANYekanBold mb-1">درحال ضبط</p>
                  </div>
                ) : (
                  <Microphone className="w-5 h-5 md:w-6 md:h-6" />
                )}
              </button>

              {/* دکمه ارسال */}
              <button
                onClick={handleSend}
                disabled={isStreaming}
                className={`
      shrink-0 rounded-full grid place-items-center
      w-[56px] h-[56px] xs:w-11 xs:h-11 sm:w-12 sm:h-12 md:w-14 md:h-14
      ${isStreaming ? "bg-[#79b9d1] cursor-not-allowed" : "bg-[#0b94ca] hover:bg-[#087cad]"}
      text-white transition
    `}
                title={isStreaming ? "ابتدا ضبط را متوقف کنید" : "ارسال"}
              >
                <SendIcon className="w-7 h-7 md:w-6 md:h-6" />
              </button>
            </div>

          </div>
        </div>
      </div>
      <Link to={'/tripFirstStep'} className="w-[60%]  lg:w-full flex items-center justify-end mx-auto font-IRANYekanBold mt-2 text-[#265069]">

        بازگشت به عقب
        <Left />
      </Link>
    </div>
  );
};

export default TripVoice;
